import * as LDClient from 'launchdarkly-js-client-sdk'
import store from '@/store'

let client

const getUserProfile = () => {
  return store?.state?.auth?.userProfile ?? {}
}

export const getDarklyClient = () => {
  return client
}

export const createDarklyClient = async () => {
  try {
    const { uaaId, email, first_name, last_name } = getUserProfile()
    const userKey = uaaId
      ? {
          user: {
            key: uaaId,
            email,
            name: first_name ? `${first_name} ${last_name}` : null,
          },
        }
      : { user: { kind: 'user', anonymous: true } }
    const context = {
      kind: 'multi',
      ...userKey,
    }

    const accountData = store.getters['business/getBusinessUser']
    if (accountData && accountData.account && accountData.account.name) {
      context['business-account'] = {
        key: accountData.account.id,
        license: accountData.account.license_type,
        name: accountData.account.name ? accountData.account.name : null,
      }
    }

    if (!client) {
      client = LDClient.initialize(process.env.VUE_APP_DARKLY_CLIENT_SIDE_KEY, context)
    }
    await client.waitForInitialization()
    return client
  } catch (err) {
    throw err
  }
}

export const getAllDarklyFlags = () => {
  return client.allFlags()
}

export const onDarklyReady = callback => {
  return client.on('ready', callback)
}

export const onDarklyFeatureFlagChange = (featureFlag, callback) => {
  return client.on(`change:${featureFlag}`, callback)
}

export const getDarklyFlagKeyValue = async flagKey => {
  if (!client.variation) {
    await client.waitForInitialization()
  }
  const result = client.variation(flagKey)
  return result
}

export const closeDarklyClient = async callback => {
  if (!client) return
  const result = await client.close(callback)
  return result
}
